import React from 'react';

const CircleSVG = ({ fill, className }) => {
  return (
    <svg
      className={className ? `${className} BigCircle` : 'BigCircle'}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448.92 448.92'
    >
      <circle fill={fill} cx='224.46' cy='224.46' r='224.46' />
    </svg>
  );
};

export default CircleSVG;
